import React from "react";
import Navigationbar from "./Navbar";
import Container from "react-bootstrap/Container";
import "bootstrap/dist/css/bootstrap.min.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import { Stack, Form } from "react-bootstrap";
import imd from "../Assets/imd.png";
import Somaiya_small from "../Assets/kjsieit-logo.svg";

function About() {
  return (
    <Container fluid className="Full p-0">
      <div>
        <Navigationbar />
      </div>

      <Container className="Main_Container">
        <Container className="About_container">
          <Card className="About_card">
            <Card.Body>
              <div>
                <Card.Subtitle className="Collaboration">
                  Collaborative Research and Development By:
                </Card.Subtitle>
                <div>
                  <Stack
                    className="Combine_Colab"
                    direction="horizontal"
                    gap={3}
                    sm={6}
                    md={6}
                    lg={12}
                  >
                    <Col className="Collaborators_col">
                      <Stack
                        className="Collaborators_div"
                        direction="vertical"
                        gap={3}
                      >
                        <img
                          alt=""
                          src={imd}
                          width="70px"
                          className="imd_logo"
                        />
                        <Card.Subtitle className="Collaborators_name">
                          India Meteorological Department, Pune
                          <br />
                          <br />
                          <a href="http://imdpune.gov.in">
                            http://imdpune.gov.in
                          </a>
                        </Card.Subtitle>
                      </Stack>
                    </Col>
                    <Col className="Collaborators_col">
                      <Stack
                        className="Collaborators_div"
                        direction="vertical"
                        gap={3}
                      >
                        <img
                          className="Somaiya_logo"
                          alt=""
                          src={Somaiya_small}
                          width="250px"
                        />
                        <Card.Subtitle className="Collaborators_name">
                          K. J. Somaiya Institute of Technology, Sion, Mumbai
                          <br />
                          <br />
                          <a href="https://kjsit.somaiya.edu.in/en">
                            https://kjsit.somaiya.edu.in/en
                          </a>
                        </Card.Subtitle>
                      </Stack>
                    </Col>
                  </Stack>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Container>

        <Container className="About_container">
          <Card className="About_card">
            <Card.Body>
              <div>
                <Card.Title className="Collaboration">Approach:</Card.Title>
                <div>
                  <Stack direction="vertical" gap={4}>
                    <div>
                      <Card.Subtitle className="Approach_title">
                        Data Source:
                      </Card.Subtitle>
                      <Card.Text className="Approach_text">
                        The data for this research is provided by India
                        Meteorological Department, Pune and is captured in
                        real-time from{" "}
                        <a href="https://imdpune.gov.in/lrfindex.php">
                          Climate Research & Services, Pune
                        </a>
                        . The system is developed using historical data of past
                        71 years – from 1951 to 2021. As the data has a temporal
                        component, a holdout method is used for learning and
                        evaluation, with 80% data (of years 1951 to 2010) used
                        for training and the recent 20% data (of years 2011 to
                        2021) used for validation. The dataset dimensions are 31
                        × 31, and consists of attributes Timestamp, Latitude,
                        Longitude, and Maximum Temperature, which allows
                        learning temperature trends over different seasons,
                        regions, and time.
                      </Card.Text>
                    </div>
                    <div>
                      <Card.Subtitle className="Approach_title">
                        Data Pre-processing:
                      </Card.Subtitle>
                      <Card.Text className="Approach_text">
                        The data is extracted from the web-based repository with
                        GRD files of maximum observed temperature for
                        spatio-temporal analysis. Further, to capture
                        intra-regional & intra-seasonal patterns, the data is
                        fragmented into the 07 IMD-defined climatic regions of
                        India & 04 climatic seasons. The data is further
                        pre-processed to handle noisy/missing values and
                        normalization, thus assuring stable input to the AI/ML
                        models.
                      </Card.Text>
                    </div>
                    <div>
                      <Card.Subtitle className="Approach_title">
                        Machine Learning:
                      </Card.Subtitle>
                      <Card.Text className="Approach_text">
                        This research and development is based on customized
                        Prediction Models trained using Machine Learning
                        algorithms. <br />
                        <br />
                        For learning spatio-temporal patterns of temperature,
                        the work uses Long Short-Term Memory (LSTM) networks,
                        which are considered to be the most effective and
                        well-known subgroup Recurrent Neural Network (RNN),
                        especially for weather prediction. The LSTM networks
                        utilize output from the prior step as the upcoming
                        step’s input, and thus are capable of identifying
                        patterns in data sequences, including numerical
                        times-series data. From the regional segments of data,
                        28 lightweight data-driven LSTM models are trained, and
                        the respective model is used from a switching based
                        ensemble. The results from these models are further
                        recombined and rescaled to produce the 31 × 31
                        dimensional spatio-temporal predictions. The models are
                        capable to predict maximum temperature values, and
                        assist heat watch.
                      </Card.Text>
                    </div>
                    <div>
                      <Card.Subtitle className="Approach_title">
                        Prediction:
                      </Card.Subtitle>
                      <Card.Text className="Approach_text">
                        The work uses maximum daily temperature readings of past
                        14 days to produce maximum temperature predictions for
                        leads of next 7 days.
                        <br />
                        <br /> In the{" "}
                        <a href="https://kjsit-imd-heatwave.kjsieit.com/">
                          Heat Watch
                        </a>{" "}
                        section, the maximum temperature values predicted
                        through the LSTM models are used with the following
                        modified context to output the impact for 7 lead days.
                        <br />
                        <b className="Approach_title">
                          Probable Heatwave Alert:
                        </b>{" "}
                        {">45°C"} (All Regions)
                        <br />
                        <b className="Approach_title">Heat Watch:</b> {">40°C"}{" "}
                        (Plains), {">37°C"} (Coastal), {">35°C"} (Hills)
                        <br />
                        <br />
                        In the{" "}
                        <a href="https://kjsit-imd-heatwave.kjsieit.com/Maximum_Temperature">
                          Maximum Temperature
                        </a>{" "}
                        section, the predictions for maximum temperature are
                        displayed for 07 lead days along with its intensity for
                        different regions.
                      </Card.Text>
                    </div>
                    <div>
                      <Card.Subtitle className="Approach_title">
                        Validation:
                      </Card.Subtitle>
                      <Card.Text className="Approach_text">
                        The current accuracy of predictions is 92.10%. Further
                        validation of this research is in-process.
                      </Card.Text>
                    </div>
                  </Stack>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Container>

        <Container className="About_container">
          <Card className="About_card">
            <Card.Body>
              <div>
                <Card.Title className="Note">Note:</Card.Title>
                <div>
                  <Stack direction="vertical" gap={4}>
                    <div>
                      <Card.Text className="Approach_text">
                        This is an experimental research product. Kindly refer{" "}
                        <a href="https://mausam.imd.gov.in/">Mausam</a> for
                        official forecasts.
                      </Card.Text>
                    </div>
                  </Stack>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Container>

        <Row>
          <div class="about_Section container-fluid">
            <div class="about_Card Team_card">
              <div class="aboutheader_container mb-4 container">
                <div class="row">
                  <div class="abouttitle_col col p-0">
                    <div class="aboutheader card-title h5">
                      <div class="vstack minBreakpoint-xs">
                        <div class="team-title">
                          Research and Mentors' Team:
                        </div>
                        <div class="team-container space-between">
                          <div class="col Team_card">
                            <div>
                              <h3 className="hs">Shri K. S. Hosalikar</h3>
                              <p> Head & Scientist - G, </p>
                              <p>Climate Research & Services & SI Division,</p>
                              <p>India Meteorological Department, Pune</p>
                              <div className="font1">
                                <a
                                  className="mail"
                                  href="mailto:ks.hosalikar@imd.gov.in"
                                >
                                  <i class="fa-solid fa-envelope"></i>
                                </a>
                                <a
                                  className="link"
                                  href="https://twitter.com/hosalikar_ks?lang=en"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <i class="fa-brands fa-twitter"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div class="col Team_card">
                            <div>
                              <h3 className="su">Dr. Suresh Ukarande</h3>
                              <p>Principal,</p>
                              <p>
                                K. J. Somaiya Institute of Technology, Sion,
                                Mumbai
                              </p>
                              <p>&</p>
                              <p>
                                Associate Dean - Faculty of Science and
                                Technology,{" "}
                              </p>
                              <p>University of Mumbai</p>
                              <div className="font2">
                                <a
                                  className="mail"
                                  href="mailto:principal.tech@somaiya.edu"
                                >
                                  <i class="fa-solid fa-envelope"></i>
                                </a>
                                <a
                                  className="link"
                                  href="https://www.linkedin.com/in/dr-suresh-ukarande"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <i class="fa-brands fa-linkedin"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div class="col Team_card">
                            <div>
                              <h3 className="rc">Dr. Rajib Chattopadhyay</h3>
                              <p>Scientist - E,</p>
                              <p>
                                Climate Research & Services - Climate
                                Information and User Interface,
                              </p>
                              <p>India Meteorological Department, Pune</p>
                              <div className="font3">
                                <a
                                  className="mail"
                                  href="mailto:rajib.chattopadhyay@imd.gov.in"
                                >
                                  <i class="fa-solid fa-envelope"></i>
                                </a>
                                <a
                                  className="link"
                                  href="https://www.linkedin.com/in/rajib-chattopadhyay-5276641b4"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <i class="fa-brands fa-linkedin"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div class="col Team_card">
                            <div>
                              <h3 className="rk">Dr. Radhika Kotecha</h3>
                              <p>
                                Associate Professor & Head - Department of
                                Information Technology,
                              </p>
                              <p>
                                K. J. Somaiya Institute of Technology, Sion,
                                Mumbai
                              </p>
                              <div className="font4">
                                <a
                                  className="mail"
                                  href="mailto:radhika.kotecha@somaiya.edu"
                                >
                                  <i class="fa-solid fa-envelope"></i>
                                </a>
                                <a
                                  className="link"
                                  href="https://www.linkedin.com/in/dr-radhika-kotecha"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <i class="fa-brands fa-linkedin"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="">
                          <p className="stod">Development Team:</p>
                          <p className="dept">
                            Students - Department of Information Technology, K.
                            J. Somaiya Institute of Technology, Sion, Mumbai
                          </p>
                        </div>
                        <div class="flex-container space-between">
                          <div class="col Team_card">
                            <div>
                              <h3 className="sd">Mr. Sharvil Dandekar</h3>
                              <p>Role: Team Lead & Data Engineering</p>
                              <div className="font5">
                                <a
                                  className="mail"
                                  href="mailto:sharvil.d@somaiya.edu"
                                >
                                  <i class="fa-solid fa-envelope"></i>
                                </a>
                                <a
                                  className="link"
                                  href="https://www.linkedin.com/in/sharvil-dandekar-141810214/"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <i class="fa-brands fa-linkedin"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div class="col Team_card">
                            <div>
                              <h3 className="op">Mr. Om Parab</h3>
                              <p>Role: Deployment & Performance Optimization</p>
                              <div className="font6">
                                <a
                                  className="mail"
                                  href="mailto:om.parab@somaiya.edu"
                                >
                                  <i class="fa-solid fa-envelope"></i>
                                </a>
                                <a
                                  className="link"
                                  href="https://www.linkedin.com/in/om-parab-90a803217/"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <i class="fa-brands fa-linkedin"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div class="col Team_card">
                            <div>
                              <h3 className="tl">Mr. Taksha Limbashia</h3>
                              <p>Role: Deployment & Performance Optimization</p>
                              <div className="font7">
                                <a
                                  className="mail"
                                  href="mailto:taksha.l@somaiya.edu"
                                >
                                  <i class="fa-solid fa-envelope"></i>
                                </a>
                                <a
                                  className="link"
                                  href="https://www.linkedin.com/in/takshalimbashia/"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <i class="fa-brands fa-linkedin"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div class="col Team_card">
                            <div>
                              <h3 className="ac">Mr. Abdurrahman Chauhan</h3>
                              <p>Role: Backend Development</p>
                              <div className="font8">
                                <a
                                  className="mail"
                                  href="mailto:abdurrahman.c@somaiya.edu"
                                >
                                  <i class="fa-solid fa-envelope"></i>
                                </a>
                                <a
                                  className="link"
                                  href="https://www.linkedin.com/in/abdurrahman-chauhan"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <i class="fa-brands fa-linkedin"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="flex-container space-between">
                          <div class="col Team_card">
                            <div>
                              <h3 className="jb">Mr. Jinay Bavishi</h3>
                              <p>Role: Machine Learning</p>
                              <div className="font9">
                                <a
                                  className="mail"
                                  href="mailto:jinay.bavishi@somaiya.edu"
                                >
                                  <i class="fa-solid fa-envelope"></i>
                                </a>
                                <a
                                  className="link"
                                  href="https://www.linkedin.com/in/jinay-bavishi-a32023268/"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <i class="fa-brands fa-linkedin"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div class="col Team_card">
                            <div>
                              <h3 className="mg">Mr. Manav Gupta</h3>
                              <p>Role: Frontend Development</p>
                              <div className="font10">
                                <a
                                  className="mail"
                                  href="mailto:manav.gupta@somaiya.edu"
                                >
                                  <i class="fa-solid fa-envelope"></i>
                                </a>
                                <a
                                  className="link"
                                  href="https://www.linkedin.com/in/manav1005/"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <i class="fa-brands fa-linkedin"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div class="col Team_card">
                            <div>
                              <h3 className="sp">Ms. Srushti Patil</h3>
                              <p>Role: Machine Learning</p>
                              <div className="font11">
                                <a
                                  className="mail"
                                  href="mailto:srushti01@somaiya.edu"
                                >
                                  <i class="fa-solid fa-envelope"></i>
                                </a>
                                <a
                                  className="link"
                                  href="https://www.linkedin.com/in/srushtipatil1"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <i class="fa-brands fa-linkedin"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div class="col Team_card">
                            <div>
                              <h3 className="vk">Mr. Varun Kanbhat</h3>
                              <p>Role: Frontend Development</p>
                              <div className="font12">
                                <a
                                  className="mail"
                                  href="mailto:varun.kanbhat@somaiya.edu"
                                >
                                  <i class="fa-solid fa-envelope"></i>
                                </a>
                                <a
                                  className="link"
                                  href="https://www.linkedin.com/in/varunkanbhat/"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <i class="fa-brands fa-linkedin"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Row>
      </Container>
    </Container>
  );
}

export default About;
